import React from 'react';

function ModalDetalhesSistema({
  acaoCancelar,
  acaoFechar,
  sistemaSelecionado,
}) {

  const cancelar = (ev) => {
    ev.preventDefault();
    acaoCancelar();
  };

  return (
    <>
      <div className="dialog-main detalhe-sistema">
        <h2>{sistemaSelecionado?.iprojTi.nome}</h2>

        <div>
          <p className="mini">Sigla:</p>
          <p className="small">{sistemaSelecionado?.iprojTi.sigla}</p>
        </div>

        <div>
          <p className="mini">Descrição do Sistema:</p>
          <p className="small">{sistemaSelecionado?.iprojTi.descricao}</p>
        </div>

        <div>
          <p className="mini">Links:</p>

          <a
            className="small txt-link"
            href={sistemaSelecionado?.iprojTi.urlHomologacao}
            >Link de homologação</a
          >
          <br />
          <a
              className="small txt-link"
              href={sistemaSelecionado?.iprojTi.urlProducao}
              >Link de produção</a
          >
        </div>
        
        <div>
          <p className="mini">Grupo(s):</p>
          {sistemaSelecionado?.listaGrupos?.map((grupo, index) => (
            <>
              <h6>{grupo.nome}</h6>
              <p className="small">{grupo.descricao}</p>
              <br />
            </>
          ))}
        </div>
      </div>
      
      <div className="dialog-footer">
        <button 
          className="btn-pre btn-fecha-dialog"
          onClick={cancelar}>
            Fechar
        </button>
      </div>
    </>
  );
}
export default ModalDetalhesSistema;
